module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/ch2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The next day")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The moment of truth had arrived. Art was out of town, Dr. Harding was sleeping, and rounds needed to be made. That left me, the greenest rookie imaginable, in charge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We had fifteen patients on our service. Most of them had hip or knee replacements—operations I had never even seen. I just wanted to get through the morning without making some terrible mistake. I decided to make rounds so early that the patients would be too sleepy to ask me any questions. I was terrified one of them might ask me something like “Doctor, when can I resume dancing (or driving, or sex) after my hip (or knee, or shoulder) replacement?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I couldn’t just say, “Beats the hell out of me.” I would have to come up with an answer. “Well, Mr. Spencer, resumption of activity following total hip replacement depends on a myriad of important factors.” I would stroke my chin and pace slowly back and forth at the foot of his bed. “One must consider the integrity of the neuroprocesses, and the coefficient of friction of the metallic implant—not to mention the specific gravity of the synovial fluid. These are very complex issues. I will ask Dr. Harding to discuss this with you on Monday morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was 4:57 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")]), _vm._v(" when I pulled into the parking lot at the west end of Methodist Hospital. As I walked in the back door, the security guard at the desk looked up from his magazine. “Emergency, huh, Doc?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah…” It was easier simply to agree. “Yeah, emergency,” I said—which was true. If I didn’t make it through rounds that morning I would be unemployed, and for me that would be a major emergency.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I went into the doctors’ lounge and was panicked to find there were no computer lists. I found out later they weren’t printed until 6:30 each morning. I had the list from the day before, but what if some French diplomat or Arabian sheik had been admitted during the night? What if he called Dr. Harding at the symphony or the golf course later that day demanding to know why no one had shown up to treat the green fungus on his femur?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My footsteps echoed down the dark halls as I made my way to the ortho floor. One of the nurses saw me pulling a chart from the rack.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is anything wrong, Doctor?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. I’m just making rounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Making rounds—at ten after five?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wanted to get an early start.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head and went back to her charting.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I stood outside the first patient’s room for several minutes, carefully reviewing the chart, checking outputs, vital signs, progress notes, and therapy records. Then I let out a slow breath and went in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mr. Radcliff?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No response.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tried again, a little louder. “Mr. Radcliff?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally, I reached over and shook his forearm. “Mr. Radcliff!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hi, Mr. Radcliff. It’s Dr. Collins.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dr. Collins, remember? I’m one of the residents with Dr. Harding.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, yeah. Dr. Connolly. Is something wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, sir. I’m just here to check on you. Mind if I take a look at your incision?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And so it went, patient after sleepy patient. I had a list of things Dr. Harding wanted done. (“Get her drain out tomorrow.” “Change his dressing.” “Put him in a cast.”) Things went pretty well until I got to Lavinia Allenbaum’s room. Mrs. Allenbaum was an eighty-two-year-old woman from a nursing home in Byron. She had fallen in the bathtub and fractured her hip. Dr. Harding had fixed it four days earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was sitting up in bed, picking at her blanket, as I entered the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good morning, Mrs. Allenbaum. I’m—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re a no-good, lying son of a bitch. That’s what you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I jerked to a halt. I felt like I had been slugged in the stomach. “Mrs. Allenbaum, if I have done anything to—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve done everything. You and the rest of them. This is the worst hotel in Milwaukee. I’m never coming back to this place again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The worst hotel in Milwaukee? Well, that explained things. Maybe I shouldn’t take it personally when she said I was a lying son of a bitch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I smiled reassuringly and went over to check her incision. I carefully lifted the edge of her hospital gown, and pulled back the dressing. The incision was healing nicely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mrs. Allenbaum slapped my hand. “What do you think you’re doing? Why you little—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry, Mrs. Allenbaum. I just needed to check your incision.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pervert! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pervert!")]), _vm._v("” She was swinging her left hand at me, making the IV pole totter precariously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mrs. Allenbaum, please. I’m one of your doctors.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re a filthy pervert. That’s what you are!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I backed away, waving my hands at her. She was shouting so loud that everyone on the floor must have heard that Mrs. Allenbaum’s doctor was a filthy pervert. “Shhh, Mrs. Allenbaum. Shhh! You don’t have to—” I backed right into a nurse who had come to investigate the commotion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, you got old Livy riled up now,” the nurse said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I held up my hands. “All I did was check her incision.” I prayed the nurse hadn’t already called the Vice Squad and the SWAT team to arrest the sicko who was molesting the old lady in 7203. Even now, 250-pound guys with huge biceps and black stockings pulled over their faces might be rappelling down the walls of the hospital, waiting to point machine guns at me and shout, “Freeze, turkey!” I would end my second day at the Mayo Clinic in the Sex Offenders Unit of the Olmsted County Jail.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Relax,” the nurse said. “Livy’s a little confused this morning. An hour ago she pulled out her IV and then tried to bite me when I restarted it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mrs. Allenbaum, clutching her gown to her chest, continued to glare at me as I backed out of the room. There were only two more patients left to see. Was I imagining things or were they looking at me funny?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By 7:30 I was back in the doctors’ lounge checking Dr. Harding’s new list. Thankfully, no French diplomats or Arabian sheiks had been admitted during the night. John Stevenson, looking a little worse for wear, was tearing out his patient list from the printer. I thanked him for the party the night before and told him I had a good time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you making rounds today?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just finished.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just finished? When did you start, six "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, five.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you nuts? Nobody makes rounds at five o’clock on Sunday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When I told John why I had rounded so early, he nodded in understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Listen,” he said, “you’re gonna do fine. Stop worrying. First of all, orthopods aren’t like fleas. Everyone isn’t out to pimp you every minute of every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Flea” is a pejorative term for an internist. Surgeons claim internists travel around in annoyingly large groups, like fleas, buzzing much and accomplishing little. They are notorious for one-upmanship.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nobody expects much from the junior residents anyway,” John went on. “Just do what you’re told, be prepared for every surgery, and read about every case on your service.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I thanked him and went home, feeling even worse. “Be prepared for every surgery.” What did that mean? Did I have to learn how to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" a total knee replacement before I had even seen one?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I peeled the cellophane from my brand-new copy of Campbell’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Operative Orthopedics")]), _vm._v(" and began poring over the sections on total hip and knee replacements—but it was a losing battle. I would read a sentence that contained an unfamiliar word. I would look up that word only to find the definition included another word I had never heard of. I would look up "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" word and pretty soon I couldn’t remember where I had started in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“So, how’d everything go?” Art asked me on Monday morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, fine,” I said, handing him his beeper. “No problems. A couple wounds are draining a little, but everyone’s okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Everyone, that is, except me. I had just spent forty-eight hours in hell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Is this, I wondered, what I have to look forward to for the next four years?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd31e838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429903073_ch02.vue
// module id = 81
// module chunks = 0